import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    borderRadius: "14px",
    padding: "30px",
    backgroundColor: "white",
  },
  loadingBox: {
    minHeight: "400px",
    height: "1005",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
    flexWrap: "wrap",
  },
  innerHeader: {
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      "& > :last-child": {
        marginLeft: "0",
      },
    },
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  headerLeftText1: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "18px",
    color: "#999999",
  },
  headerLeftText2: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "22px",
    color: "#272525",
  },
  headerRightText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#615E83",
    cursor: "default",
  },
}));

export default useStyles;
